export default __webpack_public_path__ + "static/popup-pic-003-90e29a87f9fb3118b621498f0621df30.jpg";